var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoubleCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8195 4.59929C11.0649 4.28896 11.0156 3.83506 10.7094 3.58547C10.4032 3.33589 9.95606 3.38514 9.7107 3.69547L4.1142 10.7739L2.21242 8.84328C1.93475 8.56141 1.48492 8.56096 1.20769 8.84229C0.930459 9.12362 0.930817 9.58018 1.20849 9.86206L3.67107 12.3619C3.81394 12.507 4.01075 12.5836 4.21232 12.5726C4.4139 12.5616 4.6012 12.4641 4.72745 12.3045L10.8195 4.59929ZM14.8441 4.59933C15.0894 4.28899 15.0401 3.83508 14.7339 3.58549C14.4277 3.3359 13.9806 3.38515 13.7353 3.69549L8.13888 10.774L7.71474 10.3434C7.43708 10.0615 6.98725 10.061 6.71003 10.3424C6.4328 10.6237 6.43315 11.0803 6.71081 11.3622L7.69574 12.3621C7.83861 12.5071 8.03541 12.5837 8.23699 12.5728C8.43856 12.5618 8.62587 12.4643 8.75211 12.3046L14.8441 4.59933Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleCheck);
export default __webpack_public_path__ + "static/media/double_check.eabe0221.svg";
export { ForwardRef as ReactComponent };